module.exports = __webpack_public_path__ + "static/media/layers-clear.0d0dd8fb.svg";